import {
  createGlobalConfig,
  panoramaClientFactory,
  PanoramaPlatform,
} from '@wix/panorama-client-web';

const config = window.__CONFIG__;

// Shared between all Panorama clients created in this bundle. Exported so the
// testkit can intercept reports (panoramaClientTestkit().init({ globalConfig })).
export const globalConfig = createGlobalConfig();

export const panorama = panoramaClientFactory({
  baseParams: {
    platform: PanoramaPlatform.Standalone,
    fullArtifactId: 'com.wixpress.wix-emails-viewer',
    // Replaced by yoshi at build time. Required for gradual rollout gating and
    // Sentry source maps (same value client-sentry.ts uses for the release).
    artifactVersion: process.env.ARTIFACT_VERSION,
    componentId: 'wix-emails-viewer',
    uuid: config.clientId || config.userId,
    msid: config.metaSiteId,
  },
})
  .withGlobalConfig(globalConfig)
  .client();
